import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tyt-plus-tag',
  templateUrl: './plus-tag.component.html',
  styleUrls: ['./plus-tag.component.scss']
})
export class PlusTagComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
